import React from "react";
import { NavLink } from "react-router-dom";
import "./HeroSection.css";
import { FaCarSide, FaCalendarAlt, FaPlane } from "react-icons/fa";

const HeroSection = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Bienvenue chez AMSEBRID ◇ VOYAGEUR</h1>
        <p>La meilleure agence de location de voitures à Bejaia</p>
        
        <div className="hero-buttons">
          <NavLink to="/voitures" className="btn-primary">
            <FaCarSide /> Voir nos voitures
          </NavLink>
          <NavLink to="/reservation" className="btn-secondary">
            <FaCalendarAlt /> Réserver maintenant
          </NavLink>
        </div>
        
        <div className="airport-service">
          <FaPlane className="airport-icon" />
          <span>Livraison gratuite à l'aéroport de Bejaia</span>
        </div>
        
        <div className="hero-features" style={{ display: 'none' }}>
          <div className="feature">
            <span className="feature-number">100+</span>
            <span className="feature-text">Véhicules</span>
          </div>
          <div className="feature">
            <span className="feature-number">24/7</span>
            <span className="feature-text">Support</span>
          </div>
          <div className="feature">
            <span className="feature-number">5000+</span>
            <span className="feature-text">Clients satisfaits</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
